export const STEPPER_INDEXES = {
  FIRST_STEPPER: 1,
  SECOND_STEPPER: 2,
} as const;
